var _g, _g2, _path, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 130,
    viewBox: "0 0 129 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_704_3792)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.5901,
    cy: 64.9057,
    r: 20.7927,
    fill: "#DF91F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdi_704_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2905 88.5809C78.3626 88.5809 90.5809 76.3626 90.5809 61.2905C90.5809 46.2184 78.3626 34 63.2905 34C48.2184 34 36 46.2184 36 61.2905C36 76.3626 48.2184 88.5809 63.2905 88.5809Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2905 88.5809C78.3626 88.5809 90.5809 76.3626 90.5809 61.2905C90.5809 46.2184 78.3626 34 63.2905 34C48.2184 34 36 46.2184 36 61.2905C36 76.3626 48.2184 88.5809 63.2905 88.5809Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2906 80.7837C74.0563 80.7837 82.7837 72.0563 82.7837 61.2905C82.7837 50.5247 74.0563 41.7973 63.2906 41.7973C52.5248 41.7973 43.7974 50.5247 43.7974 61.2905C43.7974 72.0563 52.5248 80.7837 63.2906 80.7837Z",
    fill: "url(#paint0_linear_704_3792)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdi_704_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2904 72.9864C69.7499 72.9864 74.9863 67.7499 74.9863 61.2905C74.9863 54.831 69.7499 49.5946 63.2904 49.5946C56.8309 49.5946 51.5945 54.831 51.5945 61.2905C51.5945 67.7499 56.8309 72.9864 63.2904 72.9864Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2904 72.9864C69.7499 72.9864 74.9863 67.7499 74.9863 61.2905C74.9863 54.831 69.7499 49.5946 63.2904 49.5946C56.8309 49.5946 51.5945 54.831 51.5945 61.2905C51.5945 67.7499 56.8309 72.9864 63.2904 72.9864Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdi_704_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2905 61.2905L39.6572 37.6572",
    stroke: "url(#paint1_linear_704_3792)",
    strokeWidth: 4.33182,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_704_3792",
    x: 0.479164,
    y: 0.794739,
    width: 128.222,
    height: 128.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6591,
    result: "effect1_foregroundBlur_704_3792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_704_3792",
    x: 25.1705,
    y: 23.1705,
    width: 76.2402,
    height: 76.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.41477
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_704_3792"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7994
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55968
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_704_3792",
    result: "effect2_dropShadow_704_3792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_704_3792",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.344692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.03407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_704_3792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_704_3792",
    x: 40.7649,
    y: 38.765,
    width: 45.0509,
    height: 45.0509,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.41477
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_704_3792"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7994
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55968
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_704_3792",
    result: "effect2_dropShadow_704_3792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_704_3792",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.344692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.03407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_704_3792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdi_704_3792",
    x: 26.6617,
    y: 24.6617,
    width: 49.6242,
    height: 49.6242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.41477
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_704_3792"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.7994
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55968
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_704_3792",
    result: "effect2_dropShadow_704_3792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_704_3792",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.344692
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.03407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_704_3792"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_3792",
    x1: 43.7974,
    y1: 63.1538,
    x2: 82.7837,
    y2: 63.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEED7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF91FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_704_3792",
    x1: 51.4262,
    y1: 61.2461,
    x2: 51.3928,
    y2: 37.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF91FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEED7A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetDark);
export default __webpack_public_path__ + "static/media/target-dark.b01ef14ad16f30f1cc4929c8c0ff011f.svg";
export { ForwardRef as ReactComponent };